import React from 'react';
import './index.scss';
import { QuestionnaireWidgetAttributes } from "./types";
import WidgetUtils from "../utils/widget-utils";
import QuestionnaireWidgetV1 from "./questionnaire-widget-v1";
import { VERSION_ONE } from "../widget-types";

export interface QuestionnaireWidgetProps {
    questionnaireWidgetAttributesJson: string|undefined;
}

const QuestionnaireWidget = (props: QuestionnaireWidgetProps) => {
    const questionnaireWidgetAttributes: QuestionnaireWidgetAttributes = JSON.parse(
        props.questionnaireWidgetAttributesJson ? props.questionnaireWidgetAttributesJson : "");

    const widgetVersion = WidgetUtils.getVersion(questionnaireWidgetAttributes);

    if (widgetVersion == VERSION_ONE) {

        let header = questionnaireWidgetAttributes?.questionnaireInfo?.heading;
        let subHeader = questionnaireWidgetAttributes?.questionnaireInfo?.subHeading;
        let answerSelectionMode = questionnaireWidgetAttributes?.answerSelectionMode;
        let answerOptions = questionnaireWidgetAttributes?.answers;
        let questionnaireCta = questionnaireWidgetAttributes?.questionnaireCta;
        let redirectPath = questionnaireCta?.buttonForwardPath;
        let buttonText = questionnaireCta?.buttonText;

        if (!!questionnaireWidgetAttributes.models) {
            const widgetModels = questionnaireWidgetAttributes.models;
            header = widgetModels.questionnaireInfo?.heading;
            subHeader = widgetModels.questionnaireInfo?.subHeading;
            answerSelectionMode = widgetModels.answerSelectionMode;
            answerOptions = widgetModels.answers;
            redirectPath = widgetModels.questionnaireCta?.buttonForwardPath;
            buttonText = widgetModels.questionnaireCta?.buttonText;
        }

        // If backend props are null, return empty widget.
        if (redirectPath === undefined || header === undefined || subHeader === undefined || answerOptions?.length < 1 || buttonText === undefined) {
            return <></>
        }

        return (
            <QuestionnaireWidgetV1
                header={header} subHeader={subHeader}
                answerSelectionMode={answerSelectionMode} answerOptions={answerOptions}
                buttonText={buttonText} redirectPath={redirectPath} />
        );
    }

    return <></>
};

export default QuestionnaireWidget;
